<mat-card-actions>
  <div class="flex items-center express-payment">
    <div class="content flex items-center">
      <mat-slide-toggle
        class="slider"
        [checked]="payment.type === PaymentType.EXPRESS"
        (change)="toggleChange($event)"
      >
      </mat-slide-toggle>
      <div class="info flex items-center">
        <div class="text">Środki u dostawcy nawet za 15 minut: 4,99 zł</div>
        <app-icon
          name="info_outlined"
          size="20"
          class="ml-10 tooltip"
          matTooltip="Gdy ta opcja jest wyłączona, środki są przekazywane w ciągu 3 dni roboczych."
          ></app-icon>
        <div class="recommended flex items-center justify-center" *ngIf="showRecommendation">
          <p class="recommended-text">Polecamy</p>
        </div>
      </div>
    </div>
  </div>
</mat-card-actions>
